module.exports = __webpack_public_path__ + "img/tp-10.bf0a96bc.png";